/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BinderFilterQueryDto,
  BinderPaginationResponseDto,
  BinderResponseDto,
  CreateBinderPayloadDto,
  ErrorResponse,
  ReplaceBinderPayloadDto,
} from '../models/index';
import {
    BinderFilterQueryDtoFromJSON,
    BinderFilterQueryDtoToJSON,
    BinderPaginationResponseDtoFromJSON,
    BinderPaginationResponseDtoToJSON,
    BinderResponseDtoFromJSON,
    BinderResponseDtoToJSON,
    CreateBinderPayloadDtoFromJSON,
    CreateBinderPayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ReplaceBinderPayloadDtoFromJSON,
    ReplaceBinderPayloadDtoToJSON,
} from '../models/index';

export interface CreateBinderRequest {
    createBinderPayloadDto: CreateBinderPayloadDto;
}

export interface DeleteBinderRequest {
    binderId: string;
}

export interface FilterBindersRequest {
    binderFilterQueryDto: BinderFilterQueryDto;
    page?: number;
    pageSize?: number;
}

export interface GetBinderByIdRequest {
    binderId: string;
}

export interface ReplaceBinderRequest {
    binderId: string;
    replaceBinderPayloadDto: ReplaceBinderPayloadDto;
}

/**
 * 
 */
export class BinderApi extends runtime.BaseAPI {

    /**
     * Create binder
     */
    async createBinderRaw(requestParameters: CreateBinderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BinderResponseDto>> {
        if (requestParameters['createBinderPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createBinderPayloadDto',
                'Required parameter "createBinderPayloadDto" was null or undefined when calling createBinder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/binder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBinderPayloadDtoToJSON(requestParameters['createBinderPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BinderResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create binder
     */
    async createBinder(requestParameters: CreateBinderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BinderResponseDto> {
        const response = await this.createBinderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete binder by id
     */
    async deleteBinderRaw(requestParameters: DeleteBinderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['binderId'] == null) {
            throw new runtime.RequiredError(
                'binderId',
                'Required parameter "binderId" was null or undefined when calling deleteBinder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/binder/{binderId}`.replace(`{${"binderId"}}`, encodeURIComponent(String(requestParameters['binderId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete binder by id
     */
    async deleteBinder(requestParameters: DeleteBinderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBinderRaw(requestParameters, initOverrides);
    }

    /**
     * Filter binders
     */
    async filterBindersRaw(requestParameters: FilterBindersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BinderPaginationResponseDto>> {
        if (requestParameters['binderFilterQueryDto'] == null) {
            throw new runtime.RequiredError(
                'binderFilterQueryDto',
                'Required parameter "binderFilterQueryDto" was null or undefined when calling filterBinders().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/binder/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BinderFilterQueryDtoToJSON(requestParameters['binderFilterQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BinderPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter binders
     */
    async filterBinders(requestParameters: FilterBindersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BinderPaginationResponseDto> {
        const response = await this.filterBindersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get binder by id
     */
    async getBinderByIdRaw(requestParameters: GetBinderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BinderResponseDto>> {
        if (requestParameters['binderId'] == null) {
            throw new runtime.RequiredError(
                'binderId',
                'Required parameter "binderId" was null or undefined when calling getBinderById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/binder/{binderId}`.replace(`{${"binderId"}}`, encodeURIComponent(String(requestParameters['binderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BinderResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get binder by id
     */
    async getBinderById(requestParameters: GetBinderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BinderResponseDto> {
        const response = await this.getBinderByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace binder
     */
    async replaceBinderRaw(requestParameters: ReplaceBinderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BinderResponseDto>> {
        if (requestParameters['binderId'] == null) {
            throw new runtime.RequiredError(
                'binderId',
                'Required parameter "binderId" was null or undefined when calling replaceBinder().'
            );
        }

        if (requestParameters['replaceBinderPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'replaceBinderPayloadDto',
                'Required parameter "replaceBinderPayloadDto" was null or undefined when calling replaceBinder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/binder/{binderId}/replace`.replace(`{${"binderId"}}`, encodeURIComponent(String(requestParameters['binderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReplaceBinderPayloadDtoToJSON(requestParameters['replaceBinderPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BinderResponseDtoFromJSON(jsonValue));
    }

    /**
     * Replace binder
     */
    async replaceBinder(requestParameters: ReplaceBinderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BinderResponseDto> {
        const response = await this.replaceBinderRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
